import RunnerSafeType from "../../enums/RunnerSafeType.js";

// @see https://www.baseball-reference.com/bullpen/Runs_scored
// @see https://www.mlb.com/glossary/standard-stats/run
// A player is awarded a run if he crosses the plate to score his team a run. When tallying runs scored, the way in which a player reached base is not considered. If a player reaches base by an error or a fielder's choice, as long as he comes around to score, he is still credited with a run. If a player enters the game as a pinch-runner and scores, he is also credited with a run.
const classifiesAsRun = function(runnerSafe) {
    switch (runnerSafe) {
        case RunnerSafeType.ExtraRunner.key:
            return false;

        default:
            return true;
    }
};

export default classifiesAsRun;
